const BookmarkedSvgFilled = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="21"
      viewBox="0 0 15 21"
      fill="none"
    >
      <path
        d="M13.069 0.5H2.15112C1.08831 0.5 0.21875 1.36957 0.21875 2.43237V19.2923C0.21875 19.7512 0.484451 20.186 0.895079 20.3792C1.32986 20.5725 1.81295 20.5242 2.17527 20.2343L2.19943 20.2101L7.61005 15.6449L13.0207 20.2101L13.0448 20.2343C13.2622 20.4034 13.5279 20.5 13.7936 20.5C13.9627 20.5 14.1559 20.4517 14.325 20.3551C14.7357 20.1618 15.0014 19.7271 15.0014 19.2681V2.43237C15.0014 1.36957 14.1318 0.5 13.069 0.5Z"
        fill="white"
      />
    </svg>
  );
};
export default BookmarkedSvgFilled;
